import React, { FC, ReactNode } from 'react'
import '../css/TourImage.scss'

type TourImageProps = {
  src: string
  alt: string
  children: ReactNode
}

const TourImage: FC<TourImageProps> = props => {
  const { src, alt, children } = props

  return (
    <div className='TourImage u-marginBottom8gu'>
      <img src={src} alt={alt} />
      {children}
    </div>
  )
}
export default TourImage
